import { FC } from 'react';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { BoxV2 as Box, Flex } from 'portal-commons';

import RcsSectionBlock from './RcsSectionBlock';
import StatusIndicator from './StatusIndicator';
import { BrandAssetStatus } from '@/apis/core';
import { humanize } from '@/utils/string';

const StatusItem: FC<{
  title: string;
  success: boolean;
  status?: string | null;
}> = ({ status, title, success }) => {
  return (
    <div>
      <Box sx={{ fontWeight: 'bold', mb: '5px', fontSize: 'H300' }}>
        {title}
      </Box>
      <Flex sx={{ alignItems: 'center' }}>
        {!!status && (
          <StatusIndicator variant={success ? 'success' : 'error'} />
        )}
        <div>{status ? humanize(status) : 'N/A'}</div>
      </Flex>
    </div>
  );
};

interface StatusSectionProps {
  data: {
    rcsVet?: string | null;
    logo?: string | null;
    banner?: string | null;
  };
}

const StatusSection: FC<StatusSectionProps> = ({ data }) => {
  return (
    <RcsSectionBlock
      icon={faCircleCheck}
      title="Status"
      showDivider={true}
      data-testid="campaignStatus "
    >
      <Box sx={{ color: 't.black80', fontSize: 'H300' }}>
        Shows the status of different verification steps necessary for the
        verification of an RCS campaign.
      </Box>
      <Flex
        sx={{ flexDirection: 'row', gap: '50px', mt: 'm', color: 't.black80' }}
      >
        <StatusItem
          title="RCS Vet"
          success={data.rcsVet === 'ACTIVE'}
          status={data.rcsVet}
        />
        <StatusItem
          title="Logo"
          success={data.logo === BrandAssetStatus.Verified}
          status={data.logo}
        />
        <StatusItem
          title="Banner"
          success={data.banner === BrandAssetStatus.Verified}
          status={data.banner}
        />
      </Flex>
    </RcsSectionBlock>
  );
};

export default StatusSection;
